/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from '@utils/loadable';

export const Qp2pPage = lazyLoad(
  () => import('./index'),
  (module) => module.Qp2pSection
);
